<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>

    <mat-dialog-actions>
      <button mat-dialog-close class="close-x-button">×</button>
    </mat-dialog-actions>
  </div>

  <mat-dialog-content>
    <h1 class="title">Carga horária de ensino</h1>
    <div class="panel">
      <app-tabela
        ngSkipHydration
        class="table-component"
        [cabecalhoCustomizado]="true"
      >
        <ng-container cabecalho>
          <tr>
            <th class="table-header" rowspan="2" style="width: 40%">Etapa</th>
            <th class="table-header" rowspan="2" style="width: 30%">Turno</th>
            <th class="table-header" style="width: 30%">
              Carga horária diária
            </th>
          </tr>
          <tr>
            <th class="table-header">PQR</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <ng-container *ngFor="let dados of dadosTabelaViewModel">
            <ng-container *ngFor="let turno of dados.turnos; index as i">
              <tr>
                <ng-container *ngIf="i === 0">
                  <td class="table-cell align-left" [attr.rowspan]="dados.turnos.length">
                    {{ dados.etapa.descricao }}
                  </td>
                </ng-container>
                <td class="table-cell align-left">{{ turno.descricao }}</td>
                <td class="table-cell">
                  <input
                    [value]="dados.pqr[i]"
                    class="display-input text-green"
                    maxlength="2"
                  />
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </app-tabela>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <button class="close-button" mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>
